<div class="dismiss-dialog">
	<div class="dismiss-dialog__header">
		<div class="pg-title">{{ title }}</div>
		<button mat-icon-button class="pg-header-btn" mat-dialog-close>
			<mat-icon>close</mat-icon>
		</button>
	</div>
	<mat-divider></mat-divider>
	<div class="dismiss-dialog__content">
		{{ content }}
	</div>
	<div mat-dialog-actions>
		<button mat-stroked-button class="dismiss-dialog__btn" mat-dialog-close>
			OK
		</button>
	</div>
</div>
